import React from "react";
import c1 from '../assets/images/c1.png';
import c2 from '../assets/images/c2.png';
import c3 from '../assets/images/c3.png';

export default function Contact() {
  const contactInfo = [
    {
      icon: c1,
      title: "Location",
      detail: "Sukkur, Sindh, Pakistan",
      subtitle: "Available for remote & on-site collaboration"
    },
    {
      icon: c2,
      title: "Email",
      detail: "hafsaqureshi486@gmail.com",
      subtitle: "Response within 24 hours"
    },
    {
      icon: c3,
      title: "Phone",
      detail: "+92 323 3******",
      subtitle: "Available Mon-Fri, 9 AM - 6 PM PKT"
    }
  ];

  return (
    <section id="contact" className="">
      <div className="container">
        {/* Header Section */}
        <div className="text-center mb-5 wow-delayed">
          <div className="d-inline-flex align-items-center mb-3">
            <div className="bg-secondary rounded-circle p-2 me-2">
              <i className="fas fa-envelope text-white"></i>
            </div>
            <span className="badge bg-light text-secondary px-3 py-2 rounded-pill fs-6">
              Get In Touch
            </span>
          </div>

          <h3 className="display-6 fw-bold text-dark mb-3">
            Let's Build Something
            <span style={{ color: 'orangered' }}> Amazing Together</span>
          </h3>

          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
            Ready to transform your ideas into reality? I'm here to help you create
            exceptional digital experiences that drive results.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {/* Contact Information Cards */}
          <div className="col-lg-6">
            <div className="row g-3">
              {contactInfo.map((item, index) => (
                <div key={index} className="col-12">
                  <div className="card h-100 border-0 shadow-sm hover-lift">
                    <div className="card-body p-4">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 me-4">
                          <div className="bg-light rounded-3 p-3">
                            <img
                              src={item.icon}
                              alt={item.title}
                              style={{ width: '32px', height: '32px' }}
                              className="img-fluid"
                            />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="card-title fw-semibold text-dark mb-2">
                            {item.title}
                          </h5>
                          <p className="card-text fw-medium mb-1" style={{ color: 'orangered' }}>
                            {item.detail}
                          </p>
                          <small className="text-muted">
                            {item.subtitle}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Call to Action Section */}
          <div className="col-lg-5">
            <div className="card border-0 shadow-lg h-100 bg-white"
           >
              <div className="card-body p-2  text-center d-flex flex-column justify-content-center">
                <div className="mb-4">
                  <div className="bg-light bg-opacity-20 rounded-circle p-3 d-inline-flex mb-3">
                    <i className="fas fa-paper-plane" style={{ fontSize: '24px',color:"red" }}></i>
                  </div>
                  <h4 className="fw-bold mb-3">Ready to Start Your Project?</h4>
                  <p className="mb-4 opacity-90">
                    Whether you need a stunning website, mobile app, or digital strategy,
                    I'm here to bring your vision to life with cutting-edge solutions.
                  </p>
                </div>

            <a
  href="mailto:hafsaqureshi486@gmail.com?subject=Project%20Inquiry&body=Hi%20Hafsa,%20I'm%20interested%20in%20discussing%20a%20project%20with%20you."
  className="btn btn-lg fw-semibold text-white"
  style={{
    backgroundColor: "orangered",
    border: "none",
    textDecoration: "none",
  }}
>
  <i className="fas fa-envelope me-2"></i>
  Start a Conversation
</a>


                <div className="mt-4 pt-3 border-top border-light">
                  <small>
                    <strong>Quick Response Guaranteed</strong><br />
                    I typically respond within 2–4 hours during business hours
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className="row mt-5 pt-5 border-top">
          <div className="col-12 text-center">
            <h5 className="fw-semibold text-dark mb-4">Why Work With Me?</h5>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="p-3">
                  <div className="rounded-circle p-3 d-inline-flex mb-3" style={{ backgroundColor: 'rgba(255, 69, 0, 0.1)' }}>
                    <i className="fas fa-rocket" style={{ fontSize: '20px', color: 'black' }}></i>
                  </div>
                  <h6 className="fw-semibold text-dark">Fast Delivery</h6>
                  <small className="text-muted">Quality work delivered on time, every time</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-3">
                  <div className="rounded-circle p-3 d-inline-flex mb-3" style={{ backgroundColor: 'rgba(255, 69, 0, 0.1)' }}>
                    <i className="fas fa-code" style={{ fontSize: '20px', color: 'orangered' }}></i>
                  </div>
                  <h6 className="fw-semibold text-dark">Modern Solutions</h6>
                  <small className="text-muted">Latest technologies and best practices</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-3">
                  <div className="rounded-circle p-3 d-inline-flex mb-3" style={{ backgroundColor: 'rgba(255, 69, 0, 0.1)' }}>
                    <i className="fas fa-headset" style={{ fontSize: '20px', color: 'orangered' }}></i>
                  </div>
                  <h6 className="fw-semibold text-dark">Ongoing Support</h6>
                  <small className="text-muted">Continued assistance after project completion</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Styling */}
      <style jsx>{`
        .hover-lift {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important;
        }
        .hover-scale {
          transition: transform 0.2s ease;
        }
        .hover-scale:hover {
          transform: scale(1.02);
        }
        .bg-gradient {
          position: relative;
          overflow: hidden;
        }
        .bg-gradient::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
          animation: shimmer 3s infinite;
        }
        @keyframes shimmer {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .wow-delayed {
          animation: fadeInUp 0.8s ease-out;
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
